import { wrappedFetch } from './urlFuncs';
import { UPDATE_PROFILE_URL} from './../inc/constants';
import {API_URL} from './../inc/config';

export const updateProfile = (data) =>{
    //console.log('data', data)
  return wrappedFetch(`${API_URL}${UPDATE_PROFILE_URL}`,'PUT',data);
    
}
